import React from 'react';
import { Helmet } from 'react-helmet-async';
import MonitoringDashboard from '../components/monitoring/MonitoringDashboard';

/**
 * Monitoring Page
 * Displays real-time data monitoring dashboard
 * WebSocket connection is managed globally in App.js
 * WebSocket context is provided at the route level
 */
const MonitoringPage = () => {
  return (
    <>
      <Helmet>
        <title>Data Monitoring | Leader Cloud</title>
      </Helmet>
      <MonitoringDashboard />
    </>
  );
};

export default MonitoringPage;
